// extracted by mini-css-extract-plugin
module.exports = {"main":"AuthRightBar_main__sb031","ghostboxDiv":"AuthRightBar_ghostboxDiv__s_6dF"};